const ProductDescriptionForSmallDeviceSkeleton = () => {
  return (
    <div className="block lg:hidden animate-pulse">
      <div className="collapse collapse-plus bg-base-200 mb-2">
        <div className="collapse-title">
          <div className="h-6 bg-gray-light rounded w-1/3"></div>
        </div>
        <div className="collapse-content">
          <div className="mt-4">
            <div className="h-4 bg-gray-light rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-light rounded w-5/6 mb-2"></div>
            <div className="h-4 bg-gray-light rounded w-2/3"></div>
          </div>
        </div>
      </div>

      <div className="collapse collapse-plus bg-base-200 mb-2">
        <div className="collapse-title">
          <div className="h-6 bg-gray-light rounded w-1/3"></div>
        </div>
        <div className="collapse-content">
          <div className="mt-4">
            <div className="h-4 bg-gray-light rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-light rounded w-5/6 mb-2"></div>
            <div className="h-4 bg-gray-light rounded w-2/3"></div>
          </div>
        </div>
      </div>

      <div className="collapse collapse-plus bg-base-200">
        <div className="collapse-title">
          <div className="h-6 bg-gray-light rounded w-1/3"></div>
        </div>
        <div className="collapse-content">
          <div className="mt-4">
            <div className="h-4 bg-gray-light rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-light rounded w-5/6 mb-2"></div>
            <div className="h-4 bg-gray-light rounded w-2/3"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDescriptionForSmallDeviceSkeleton;
